import {createSlice} from "@reduxjs/toolkit";
import {addError} from "src/slices/errors";
import {getOrganisations, getOrganizationDetails} from "../api/organization";


const initialState = {
    currentOrganization: {},
    loadingCurrentOrganization: false,
    organisationsList: {list: [], totalElements: 0, pageNumber: 0, totalPages: 0},
    loadingOrganisationsList: false,
    isCreateOrganisationStarted: false,
    loadingRenewingOrganisation: false
};

const slice = createSlice({
    name: "organization",
    initialState,
    reducers: {
        setLoadingCurrentOrganization(state, action) {
            state.loadingCurrentOrganization = action.payload;
        },
        resetCurrentOrganization(state) {
            state.currentOrganization = initialState.currentOrganization;
        },
        setCurrentOrganization(state, action) {
            const {currentOrganization} = action.payload;
            state.currentOrganization = currentOrganization;
        },
        setLoadingOrganisationsList(state, action) {
            state.loadingOrganisationsList = action.payload;
        },
        setOrganisationsList(state, action) {
            state.organisationsList = action.payload;
        },
        setCreatingOrganisation(state, action) {
            const {isStarted} = action.payload;
            state.isCreateOrgnisationStarted = isStarted;
        },
        setLoadingRenewingOrganisation(state, action) {
            state.loadingRenewingOrganisation = action.payload;
        }
    }
});

export const reducer = slice.reducer;

export const getCurrentOrganization = organizationId => async dispatch => {
    dispatch(slice.actions.setLoadingCurrentOrganization(true));
    dispatch(slice.actions.resetCurrentOrganization());

    let currentOrganization = initialState.currentOrganization;

    try {
        const getOrganizationResponse = await getOrganizationDetails(organizationId);
        currentOrganization = getOrganizationResponse.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setCurrentOrganization({currentOrganization}));
    dispatch(slice.actions.setLoadingCurrentOrganization(false));
};

export const getOrganisationsList = (tenantId, query, page, limit, sortBy, sortDir) => async dispatch => {
    dispatch(slice.actions.setLoadingOrganisationsList(true));

    let organisationsList = initialState.organisationsList;

    try {
        const response = await getOrganisations(tenantId, query, page, limit, sortBy, sortDir);
        organisationsList = response.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setOrganisationsList({organisationsList}));
    dispatch(slice.actions.setLoadingOrganisationsList(false));
};


export default slice;
